import './Form.global.scss';
import React, { lazy, Suspense } from 'react';
import { ppData } from '../../configs/ppData.config';
import { ClassicFormSkeleton } from './Classic/ClassicForm.Skeleton';
import { TilesFormSkeleton } from './Tiles/TilesForm.Skeleton';
import { CustomCanvasFormSkeleton } from './CustomCanvas/CustomCanvasForm.Skeleton';
import { CustomHexagonSkeleton } from './CustomHexagon/CustomHexagon.Skeleton';
import { CustomWallDisplayFormSkeleton } from './CustomWallDisplay/CustomWallDisplayForm.Skeleton';
const ClassicForm = lazy(async () => await import('./Classic/ClassicForm'));
const StoryForm = lazy(async () => await import('./Story/StoryForm'));
const TilesForm = lazy(async () => await import('./Tiles/TilesForm'));
const CustomCanvasForm = lazy(async () => await import('./CustomCanvas/CustomCanvasForm'));
const CustomHexagonForm = lazy(async () => await import('./CustomHexagon/CustomHexagonForm'));
const CustomWallDisplayForm = lazy(async () => await import('./CustomWallDisplay/CustomWallDisplayForm'));
export const Form = () => {
    if (ppData.isStory) {
        return (React.createElement(Suspense, { fallback: React.createElement(ClassicFormSkeleton, null) },
            React.createElement(StoryForm, null)));
    }
    if (ppData.isTiles) {
        return (React.createElement(Suspense, { fallback: React.createElement(TilesFormSkeleton, null) },
            React.createElement(TilesForm, null)));
    }
    if (ppData.isCustomCanvas || ppData.isCustomFramedCanvas) {
        return (React.createElement(Suspense, { fallback: React.createElement(CustomCanvasFormSkeleton, null) },
            React.createElement(CustomCanvasForm, null)));
    }
    if (ppData.isCustomHexagon) {
        return (React.createElement(Suspense, { fallback: React.createElement(CustomHexagonSkeleton, null) },
            React.createElement(CustomHexagonForm, null)));
    }
    if (ppData.isCustomWallDisplay) {
        return (React.createElement(Suspense, { fallback: React.createElement(CustomWallDisplayFormSkeleton, null) },
            React.createElement(CustomWallDisplayForm, null)));
    }
    return (React.createElement(Suspense, { fallback: React.createElement(ClassicFormSkeleton, null) },
        React.createElement(ClassicForm, null)));
};
